// extracted by mini-css-extract-plugin
export default {"container":"dashBoardPage_container__Qczqk","container__outlet":"dashBoardPage_container__outlet__LBSHn","container__outlet__box":"dashBoardPage_container__outlet__box__DE6VW"};